import { useEffect, useState } from 'react';
import * as React from 'react';
import { pcommon, pcompany } from '@/proto/proto';
import api from '@/api';
import { Button, PageHeader, Table, Tag, Typography } from 'antd';
import { Link } from 'react-router-dom';
import moment from 'moment';
import {
  API_COMPANY_CAR,
  FORMAT_DATE_EXCEPT_SECOND_KR,
  FORMAT_DATE_EXCEPT_YEAR_SECOND_KR,
  PATH_COMPANY_CAR_IMPORT,
  PATH_COMPANY_CAR_WRITE,
} from '@/constants/constant';
import { useSelector } from 'react-redux';
import { RootState } from '@/rootReducer';

const CompanyCarListPage: React.FC = () => {
  const { user } = useSelector((state: RootState) => state.account);
  const [cars, setCars] = useState<pcompany.PbCompanyCar[]>();

  useEffect(() => {
    if (user.company) {
      api
        .get(API_COMPANY_CAR, {
          params: {
            companyId: user.company[0].base.id,
            size: 1000,
          },
        })
        .then(({ data }) => setCars(data.car));
    }
  }, [user.company]);

  return (
    <PageHeader
      title="차량 목록"
      subTitle="등록된 차량 목록"
      extra={[
        <Button>
          <Link to={PATH_COMPANY_CAR_WRITE}>등록</Link>
        </Button>,
        <Button>
          <Link to={PATH_COMPANY_CAR_IMPORT}>불러오기</Link>
        </Button>,
      ]}
      style={{ background: '#fff', border: '1px solid rgb(235, 237, 240)' }}
    >
      <Table dataSource={cars}>
        <Table.Column title="차량번호" dataIndex="plateNo" key="plateNo" />
        <Table.Column title="상태" dataIndex="statusName" key="statusName" render={(statusName) => <Tag>{statusName}</Tag>} />
        <Table.Column
          title="등록일"
          dataIndex="base"
          key="createdAt"
          sorter={(a: pcompany.IPbCompanyCar, b: pcompany.IPbCompanyCar) => moment(a.base?.createdAt).unix() - moment(b.base?.createdAt).unix()}
          defaultSortOrder="descend"
          sortDirections={['descend', 'ascend']}
          render={(base: pcommon.IPbBase) => {
            const createAt = moment(base.createdAt);
            const format = createAt.year() === moment().year() ? FORMAT_DATE_EXCEPT_YEAR_SECOND_KR : FORMAT_DATE_EXCEPT_SECOND_KR;
            return <Typography.Text>{createAt.format(format)}</Typography.Text>;
          }}
        />
      </Table>
    </PageHeader>
  );
};

export default CompanyCarListPage;
